export default __webpack_public_path__ + "static/bali-d586714e8e75d0f92d0183f2fa5771d0.png";